import React from 'react'
import styles from './Blanket.module.scss'

const Blanket = (): JSX.Element => {
  return <div className={styles.blanket}></div>
}

export default Blanket
